import i18n from '@/configs/i18n'
import vi from './vi.json'
import en from './en.json'
import viAxiosError from './axios-error.vi.json'
import enAxiosError from './axios-error.en.json'

// Registers this module's `employee` namespace (see configs/i18n).
i18n.addResourceBundle('vi', 'employee', vi)
i18n.addResourceBundle('en', 'employee', en)
// API errors read by the shared error handler stay owned by this module.
i18n.addResourceBundle('vi', 'axios-error', viAxiosError, true, false)
i18n.addResourceBundle('en', 'axios-error', enAxiosError, true, false)
